<template>
  <div class="container-bg vh-100">
    <div class="container  py-5 ">
      <div class=" p-4 filter border border-info rounded">
        <h1 class="pt-3 mb-4  h1--title">Contraseña</h1>
        <FormPassword
          :cleanForm="cleanForm"
          @handleChangePassword="changePassword"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FormPassword from "../components/ChangePassword/FormPassword";
export default {
  components: {
    FormPassword,
  },
  data() {
    return {
      cleanForm: new Date(),
    };
  },
  methods: {
    changePassword(data) {
      this.$loading.show()
      this.$store
        .dispatch({ type: "auth/changePassword", data:{password: data} })
        .then((resp) => {
            this.$loading.hide()
          this.$swal.fire("Éxito", `${resp.message}`, "success");
          this.cleanForm = new Date();
        })
        .catch((e) => {
            this.$loading.hide()
          this.$swal.fire("Error", e.message, "error");
        });
    },
  },
};
</script>
<style scoped></style>
